import React from "react";
import Box from "@mui/material/Box";
import FiltersAndGrid from "./FiltersAndGrid";
import Typography from "@mui/material/Typography";

export default function DoubleFiltersGrids(props) {
	return (
		<Box
			sx={{
				display: "flex",
				width: "100%",
				height: "100%",
				flexGrow: 1,
				minHeight: 0,
				flexDirection: props.row ? "row" : "column",
			}}
		>
			{props.titles?.[0] && (
				<Typography
					align="center"
					sx={{
						fontWeight: "bold",
						fontSize: 15,
					}}
				>
					{props.titles[0]}
				</Typography>
			)}
			<FiltersAndGrid
				sx={{
					padding: 1,
					...(props.row && { flex: props.topProps?.flex ?? 1 }),
				}}
				{...props.topProps}
			/>
			{props.titles?.[1] && (
				<Typography
					align="center"
					sx={{
						fontWeight: "bold",
						fontSize: 15,
						mt: 1, //margin-top
					}}
				>
					{props.titles[1]}
				</Typography>
			)}
			<FiltersAndGrid
				sx={
					props.bottomSX || {
						pt: props.row ? 0 : 1,
						pb: 1,
						pl: 1,
						pr: 1,
						mt: props.row ? 0 : 3, //margin-top
						...(props.row && { flex: props.bottomProps?.flex ?? 1 }),
					}
				}
				{...props.bottomProps}
			/>
		</Box>
	);
}
